export default __webpack_public_path__ + "static/media/button_upload_zh_tw.ddc064ca.svg";